import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderHandelssortimentBaseCommand } from "./ArbetsorderHandelssortimentBaseCommand";

export class DeleteArbetsorderHandelssortimentCommand extends ArbetsorderHandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteArbetsorderHandelssortimentCommand";

    constructor(handelssortimentId: number, arbetsorderId: number) {
        super(DeleteArbetsorderHandelssortimentCommand.$type, CommandType.Delete);
        this.handelssortimentId = handelssortimentId;
        this.arbetsorderId = arbetsorderId;
    }
}
